<template>
  <content-box class="shift-jam--wrap" :width="'640px'">
    <div class="title">{{ $t(`plan.jam.heatmapJam.shift.title`) }} <i class="icon icon--close-btn" @click="onShift"></i></div>
    <div class="action--wrap">

      <div class="jam--wrap">
        <i class="icon icon--jam--85px margin"></i>
        <span class="title">{{ $t('plan.jam.myJam') }}</span>
        <div class="amount--wrap">
          <span class="amount">{{ remainJam | thousand }}</span>
          <span class="count">{{ $t('plan.jam.jamAmount') }}</span>
        </div>
        <div class="button--wrap">
          <button class="topup" @click="topup" :disabled="planData.hasPlan">
            <i class="icon icon--plus-black"></i>
            <span class="text">{{ $t('plan.jam.chargeJamShort') }}</span>
          </button>
        </div>
        <div class="content__toast left" v-if="showHeatmapToastLayer">
          <span>{{ $t('plan.jam.moveJam') }}</span>
          <i class="icon icon--check-green-size16"></i>
        </div>
      </div>
      <div class="count--wrap">
        <div class="content" :style="{'margin-top': 'auto', 'margin-bottom': 'auto'}">
          <div class="move-button">
            <ui-button :iconName="'icon--minus-black'"
                       :size="'large'"
                       :disabled="remainJam===0 || toHeatmapAmount===0"
                       @click="setShiftAmountToHeatmap(-1)"></ui-button>
            <input class="text-input"
                   :class="{disabled: remainJam===0}"
                   type="'text'"
                   :disabled="remainJam===0"
                   v-model="toHeatmapAmount"
                   @focus="toBasket = true"
                   @blur="toHeatmapAmount === 0 ? toBasket = false : toBasket = true"
                   @input="setShiftAmountToHeatmap"/>
            <ui-button :iconName="'icon--plus-black'"
                       :size="'large'"
                       :disabled="remainJam===0"
                       @click="setShiftAmountToHeatmap(1)"></ui-button>
          </div>
          <button class="move" :class="{disabled: toHeatmapAmount===0 || !toBasket || remainJam===0}" @click="moveToHeatmap" :disabled="toHeatmapAmount===0 || !toBasket">{{ $t('plan.jam.heatmapJam.shift.button') }}</button>
          <span class="description" :style="{opacity: (!defaultState || remainJam===0)  && !toBasket ? 0.3 : 1}">{{ $t('plan.jam.heatmapJam.shift.move.toBasket') }}</span>
          <i class="icon icon--jam-shift-to-right" :class="{ active: toBasket}" :style="{opacity: (!defaultState || remainJam===0) && !toBasket ? 0.3 : 1}"></i>
        </div>
        <div v-if="!canMoveToMyJam" class="content">
          <i class="icon icon--jam-shift-to-left" :style="{opacity: ((!canMoveToMyJam || heatmapJam===0) || !defaultState) && !toMyjam  ? 0.3 : 1}"></i>
          <span class="description" :style="{opacity: ((!canMoveToMyJam || heatmapJam===0) || !defaultState) && !toMyjam  ? 0.3 : 1}">{{ $t('plan.jam.heatmapJam.shift.move.toMyJam') }}</span>
          <span class="description" :class="{cantmove: true}" v-html="$t('plan.jam.heatmapJam.shift.cantMove')"></span>

        </div>
        <div v-else class="content" :class="{'disabled': !canMoveToMyJam || !heatmapJam}">
          <i class="icon icon--jam-shift-to-left" :class="{ active: toMyjam}" :style="{opacity: ((!canMoveToMyJam || heatmapJam===0) || !defaultState) && !toMyjam ? 0.3 : 1}"></i>
          <span class="description" :style="{opacity: ((!canMoveToMyJam || heatmapJam===0) || !defaultState) && !toMyjam ? 0.3 : 1}">{{ $t('plan.jam.heatmapJam.shift.move.toMyJam') }}</span>
          <div class="move-button">
            <ui-button :iconName="'icon--minus-black'"
                       :size="'large'"
                       :disabled="!canMoveToMyJam || heatmapJam===0 || toMyJamAmount===0"
                       @click="setShiftAmountToMyJam(-1)"></ui-button>
            <input class="text-input"
                   type="'text'"
                   :class="{disabled: !canMoveToMyJam || heatmapJam===0}"
                   :disabled="!canMoveToMyJam || heatmapJam===0"
                   v-model="toMyJamAmount"
                   @input="setShiftAmountToMyJam"/>
            <ui-button :iconName="'icon--plus-black'"
                       :size="'large'"
                       :disabled="!canMoveToMyJam || heatmapJam===0"
                       @click="setShiftAmountToMyJam(1)"></ui-button>
          </div>
          <button class="move" :class="{disabled: toMyJamAmount===0 || !canMoveToMyJam || heatmapJam===0 || !toMyjam}" @click="moveToJam" :disabled="toMyJamAmount===0 || !toMyjam" >{{ $t('plan.jam.heatmapJam.shift.button') }}</button>
        </div>
      </div>
      <div class="jam--wrap">
        <i class="icon icon--jam-basket margin"></i>
        <span class="title">{{ $t('plan.jam.heatmapJam.description.title') }}
          <ui-icon-tooltip :style="{'vertical-align': 'middle'}" :iconSize="'outline-white'" arrowBottom arrowCenter>
            <span v-html="$t('plan.jam.heatmapJam.description.tooltip')"></span>
          </ui-icon-tooltip>
        </span>
        <div class="amount--wrap heatmap">
          <span class="amount">{{ heatmapJam | thousand }}</span>
          <span class="count">{{ $t('plan.jam.jamAmount') }}</span>
        </div>
        <div class="content__toast right" v-if="showJamToastLayer">
          <span>{{ $t('plan.jam.moveJam') }}</span>
          <i class="icon icon--check-green-size16"></i>
        </div>
      </div>
    </div>
    <div class="jam-pv-desc">
      <span>
        {{ $t('plan.jam.moveDescription') }}
      </span>
    </div>
  </content-box>
</template>
<script>
import ContentBox from '@/components/ui/ContentBox'
import UiButton from '@/components/ui/UiButton'
import UiIconTooltip from '@/components/ui/UiIconTooltip'
import store from '@/store'

import { checkMoveToMyJam, getRemainJam, moveToHeatmap, moveToJam } from '@/api/jam'
import { mapState } from 'vuex'

export default {
  components: {
    ContentBox,
    UiIconTooltip,
    UiButton
  },
  props: [
    'heatmapJam',
    'remainJam',
    'userData'
  ],
  data () {
    return {
      toHeatmapAmount: 0,
      toMyJamAmount: 0,
      registerData: null,
      showJamToastLayer: false,
      showHeatmapToastLayer: false,
      canMoveToMyJam: true,
      toBasket: false,
      toMyjam: false,
      defaultState: true
    }
  },
  computed: {
    ...mapState([
      'planData'
    ]),
    isShiftToHeatmap () {
      if (this.toHeatmapAmount > 0) {
        return true
      } else {
        return false
      }
    },
    isShiftToMyJam () {
      if (this.toMyJamAmount > 0) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    topup () {
      this.$emit('isChargingJam', { action: true, remainJam: this.remainJam })
    },
    onRemainJamChange () {
      this.setRemainJam()
    },
    onRegisterDataChange (value) {
      this.registerData = value
    },
    onShift () {
      this.$emit('isShiftJam', false)
    },
    moveToHeatmap () {
      const param = {
        jamCount: this.toHeatmapAmount
      }
      moveToHeatmap(param, true).then((resp) => {
        this.showJamToastLayer = true
        this.$emit('moveJam', resp.baApplyBasketCount[0], resp.jamCount.freeCount + resp.jamCount.paidCount)
        setTimeout(() => {
          this.showJamToastLayer = false
        }, 2000)
      })
    },
    moveToJam () {
      const param = {
        baApplyBasketCount: this.toMyJamAmount
      }
      moveToJam(param, true).then((resp) => {
        this.showHeatmapToastLayer = true
        this.$emit('moveJam', resp.baApplyBasketCount[0], resp.jamCount.freeCount + resp.jamCount.paidCount)
        setTimeout(() => {
          this.showHeatmapToastLayer = false
        }, 2000)
      })
    },
    setRemainJam () {
      const payload = {}
      getRemainJam(payload, true).then(res => {
        this.remainJam = res.paidCount + res.freeCount
        store.commit('setTotalRemainJam', res.paidCount + res.freeCount)
      }).catch(err => {
        console.log(err)
      })
    },
    setShiftAmountToHeatmap (value) {
      if (value) {
        this.toHeatmapAmount = this.toHeatmapAmount + value
      }
      this.toHeatmapAmount = parseInt(this.toHeatmapAmount) || 1
      if (this.toHeatmapAmount > this.remainJam) {
        this.toHeatmapAmount = this.remainJam
      } else if (this.toHeatmapAmount < 1) {
        this.toHeatmapAmount = 1
      }
      this.toBasket = true
      this.toMyjam = false
      this.defaultState = false
    },
    setShiftAmountToMyJam (value) {
      if (value) {
        this.toMyJamAmount = this.toMyJamAmount + value
      }
      this.toMyJamAmount = parseInt(this.toMyJamAmount) || 1
      if (this.toMyJamAmount > this.heatmapJam) {
        this.toMyJamAmount = this.heatmapJam
      } else if (this.toMyJamAmount < 1) {
        this.toMyJamAmount = 1
      }
      this.toBasket = false
      this.toMyjam = true
      this.defaultState = false
    }
  },
  created () {
    checkMoveToMyJam(true).then((resp) => {
      this.canMoveToMyJam = resp.checkResult
    })
  }
}
</script>
<style lang="scss" scoped>
.shift-jam--wrap {
  padding: 30px;
  box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.16), 0px 8px 15px 0px rgba(0, 0, 0, 0.16);
  .title {
    color: #2F2F2F;
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
    position: relative;
    text-align: left;
    .icon {
      position: absolute;
      right: -20px;
      top: -20px;
    }
  }

  .action--wrap {
    display: flex;
    position: relative;
    padding: 35px 0 26px;

    .jam--wrap {
      position: relative;
      width: 190px;
      height: 380px;
      border-radius: 5px;
      border: 1px solid #D7D7D7;
      background: #F4F4F4;
      display: flex;
      align-items: center;
      flex-direction: column;

      .icon--jam-basket,
      .icon--jam--85px {
        width: 57px;
        height: 57px;
        background-size: contain;
      }

      .margin {
        margin-top: 100px;
      }

      .title {
        color: #2F2F2F;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        padding: 18px 0px 10px 0px;
      }
      .amount--wrap {
        display: table;
        color: #FC6A00;
        .amount {
          display: table-cell;
          font-size: 26px;
          font-style: normal;
          font-weight: 600;
        }
        .count {
          display: table-cell;
          font-size: 14px;
          font-style: normal;
          font-weight: 600;
          line-height: 30px;
          padding-left: 3px;
        }
        &.heatmap {
          color: #FF5B8C;
        }
      }
      .button--wrap {
        padding-top: 13px;
        .topup {
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 20px;
          height: 34px;
          font-size: 14px;
          font-weight: 500;
          background-color: #fff;
          border: 1px solid #bbb;
          box-sizing: border-box;
          color: #444;

          & .icon {
            padding: 0 6px 0 11px;
            background-position: center;
          }

          & span {
            line-height: 34px;
            padding-right: 13px;
          }
        }
      }

      .content__toast {
        display: inline-block;
        border-radius: 6px;
        box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16);
        background-color: rgba(0,0,0,0.85);
        position: absolute;
        height: 32px;
        width: calc(100% + 26px);
        z-index: 99999;

        &.left {
          bottom: 60px;
        }
        &.right {
          top: 60px;
        }

        span {
          font-size: 13px;
          font-weight: 500;
          color: #57ab00;
          line-height: 13px;
          display: inline-block;
          padding: 10px;
        }

        i {
          display: inline-block;
          margin: -2px 0;
          padding-left: 10px;
        }
      }
    }

    .count--wrap {
      padding: 30px 20px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        .move-button {
          padding-top: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          .text-input {
            width: 70px;
            height: 38px;
            border-radius: 6px;
            border: 1px solid #E6E6E6;
            background-color: #ffffff;
            vertical-align: middle;
            text-align: center;
            font-size: 16px;
            color: #2f2f2f;
            margin: 0 5px;
            &.disabled {
              border: #E6E6E6;
              background-color: #E6E6E6;
              opacity: 0.3;
            }
            &:focus {
              border: 1px solid #289eef;
            }
          }
          button {
            min-width: 0;
            padding-right: 2px;
            vertical-align: middle;
          }
        }
        .move {
          width: 80px;
          height: 34px;
          background-color: #EC0047;
          font-weight: 500;
          color: #fff;
          border-radius: 20px;
          margin: 12px 0px 10px 0px;
          &.disabled {
            background-color: #D6D6D6;
          }
        }
        .description {
          color: #767676;
          text-align: center;
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          &.cantmove {
            margin-top: 10px;
            margin-bottom: 60px;
            color: #767676;
            text-align: center;
            font-size: 13px;
            font-style: normal;
            font-weight: 500;
            line-height: 17px; /* 130.769% */
          }
        }

        &.disabled {
          & .description {
            opacity: 0.3;
          }
        }
      }
    }
  }
  .jam-pv-desc {
    position: relative;
    display: block;
    width: 100%;
    height: 17px;
    line-height: 17px;
    text-align: center;

    & span {
      display: inline;
      position: absolute;
      width: 100%;
      left: 50%;
      bottom: 0;
      transform: translate(-50%, 0);
      color: #767676;
      text-align: center;
      font-size: 13px;
      font-style: normal;
      font-weight: 500;
      line-height: 17px;
    }
  }
}
</style>
